"use client";

import React from "react";
import { ArrowRight, Mail } from "lucide-react";

/**
 * SolutionForAgenciesAndFreelancers — Section 8: Final CTA
 * Drop-in für: src/pages/SolutionForAgenciesAndFreelancers/sections/CallToAction.tsx
 *
 * Dunkler CTA-Block (passend für B2B), Mail-Action statt Sign-Up.
 */

export default function CallToAction() {
  return <section className="relative w-full bg-foreground text-background py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-foreground to-gray-900 z-0" />

      <div className="relative z-10 container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-background drop-shadow-md leading-tight">
            Bereit, Ihr Web-Business zu skalieren?
          </h2>
          <p className="text-lg md:text-xl text-background/80 max-w-2xl mx-auto font-medium leading-relaxed">
            Kontaktieren Sie uns für Ihre individuellen Agentur-Konditionen.
            Wir melden uns innerhalb von 24 Stunden.
          </p>
          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="mailto:info@pagemaker24.ch?subject=AGENTUR%20%26%20Freelancer" className="group inline-flex items-center justify-center gap-2 bg-primary text-white rounded-full px-10 py-4 text-base md:text-lg font-bold shadow-2xl shadow-primary/30 transition-all duration-300 hover:scale-105">
              <Mail className="w-5 h-5" />
              Agentur-Konditionen anfragen
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="text-sm text-background/60">
              5er-, 20er-, 50er- oder Custom-Pakete
            </p>
          </div>
        </div>
      </div>
    </section>;
}